import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { Seo } from "./Seo";

const SEO = {
  "/": {
    title: "Carte de visite NFC & fiche digitale professionnelle | BBR.GO",
    description: "BBR.GO crée vos cartes de visite NFC, badges NFC personnalisés et fiches digitales professionnelles. Partagez vos coordonnées en un geste, sans contact. Devis rapide.",
  },
  "/a-propos": {
    title: "À propos de BBR.GO — cartes NFC & fiches digitales",
    description: "BBR.GO, imaginé par deux entrepreneurs pour moderniser les interactions professionnelles grâce au NFC.",
  },
  "/nfc": {
    title: "Solutions NFC : cartes & badges pour professionnels | BBR.GO",
    description: "Découvrez les solutions NFC BBR.GO : cartes de visite et badges NFC personnalisés pour partager votre profil professionnel en un geste.",
  },
  "/fiches-digitales": {
    title: "Fiche digitale & profil professionnel en ligne | BBR.GO",
    description: "Créez votre fiche digitale professionnelle : coordonnées, réseaux, site, documents. Accessible via NFC ou QR code, toujours à jour.",
  },
  "/fonctionnement": {
    title: "Comment fonctionne une carte de visite NFC ? | BBR.GO",
    description: "NFC ou QR code : découvrez comment partager votre profil professionnel en un geste, sans application, en quelques secondes.",
  },
  "/tarifs": {
    title: "Tarifs des abonnements cartes & fiches NFC | BBR.GO",
    description: "Des abonnements adaptés à chaque besoin, de la fiche individuelle à l'entreprise. Choisissez le forfait BBR.GO qui vous correspond.",
  },
  "/faq": {
    title: "Questions fréquentes sur les cartes NFC | BBR.GO",
    description: "Tout savoir sur les cartes de visite NFC, les fiches digitales et le fonctionnement de BBR.GO.",
  },
  "/contact": {
    title: "Contact & devis carte de visite NFC | BBR.GO",
    description: "Un projet de cartes de visite NFC ou de fiches digitales ? Contactez BBR.GO pour un devis personnalisé.",
  },
  "/mentions-legales": {
    title: "Mentions légales | BBR.GO",
    description: "Mentions légales du site BBR.GO.",
  },
  "/confidentialite": {
    title: "Politique de confidentialité | BBR.GO",
    description: "Politique de confidentialité et gestion des données personnelles de BBR.GO.",
  },
};

const HOME_JSONLD = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "BBR.GO",
    url: "https://bbrgo.fr",
    logo: "https://bbrgo.fr/logo-bbrgo.png",
    email: "contactbbrgo@gmail.com",
    description: "Cartes de visite NFC, badges NFC personnalisés et fiches digitales professionnelles.",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "BBR.GO",
    url: "https://bbrgo.fr",
    inLanguage: "fr-FR",
  },
];

export default function SiteLayout() {
  const { pathname } = useLocation();
  const meta = SEO[pathname] || SEO["/"];
  return (
    <div className="min-h-screen bg-[#05050A]">
      <Seo title={meta.title} description={meta.description} path={pathname} jsonLd={pathname === "/" ? HOME_JSONLD : undefined} />
      <Navbar />
      <main className="pt-16">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
